import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path d="M12 14.5L17 9.5H7L12 14.5Z" xmlns="http://www.w3.org/2000/svg" />,
  "CaretDown"
);
